/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Features_Gamedetails1Inputs */

const id_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi detail game, peringkat, dan ulasan pengguna`)
};

const ms_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai butiran permainan, penilaian, dan ulasan pengguna`)
};

const da_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk spildetaljer, bedømmelser og brugeranmeldelser`)
};

const de_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie Spieldetails, Bewertungen und Benutzerrezensionen`)
};

const en_us2_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore game details, ratings, and user reviews`)
};

const es_es2_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora detalles de juegos, calificaciones y reseñas de usuarios`)
};

const es_mx2_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora detalles de juegos, calificaciones y reseñas de usuarios`)
};

const fil_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galugarin ang mga detalye ng laro, rating, at review ng user`)
};

const fr_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer les détails des jeux, les notes et les avis des utilisateurs`)
};

const it_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora i dettagli dei giochi, le valutazioni e le recensioni degli utenti`)
};

const hu_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játékrészletek, értékelések és felhasználói vélemények felfedezése`)
};

const nl_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek game-details, beoordelingen en gebruikersreviews`)
};

const no_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk spilldetaljer, vurderinger og brukeromtaler`)
};

const pl_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkrywaj szczegóły gier, oceny i recenzje użytkowników`)
};

const pt_br2_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore detalhes do jogo, classificações e análises de usuários`)
};

const pt_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore detalhes de jogos, classificações e avaliações de utilizadores`)
};

const ro_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorează detaliile jocurilor, evaluările și recenziile utilizatorilor`)
};

const fi_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutki pelien yksityiskohtia, arvioita ja käyttäjäarvosteluja`)
};

const sv_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska spelinformation, betyg och användarrecensioner`)
};

const vi_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá chi tiết game, xếp hạng và đánh giá người dùng`)
};

const tr_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun detaylarını, derecelendirmeleri ve kullanıcı yorumlarını keşfedin`)
};

const cs_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumávejte detaily her, hodnocení a uživatelské recenze`)
};

const bg_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изследвайте детайли на игри, оценки и потребителски ревюта`)
};

const ru_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучайте детали игр, рейтинги и пользовательские обзоры`)
};

const uk_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досліджуйте деталі ігор, рейтинги та відгуки користувачів`)
};

const ar_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشاف تفاصيل الألعاب والتقييمات ومراجعات المستخدمين`)
};

const hi_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गेम विवरण, रेटिंग और उपयोगकर्ता समीक्षाएँ देखें`)
};

const th_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำรวจรายละเอียดเกม คะแนน และรีวิวผู้ใช้`)
};

const ja_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームの詳細、評価、ユーザーレビューを探索`)
};

const zh_cn2_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索游戏详情、评分和用户评论`)
};

const zh_hant1_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索遊戲詳情、評分和使用者評論`)
};

const ko_privacy_features_gamedetails1 = /** @type {(inputs: Privacy_Features_Gamedetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 세부 정보, 평점 및 사용자 리뷰 탐색`)
};

/**
* | output |
* | --- |
* | "Explore game details, ratings, and user reviews" |
*
* @param {Privacy_Features_Gamedetails1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_features_gamedetails1 = /** @type {((inputs?: Privacy_Features_Gamedetails1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Features_Gamedetails1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_features_gamedetails1(inputs)
	if (locale === "ms") return ms_privacy_features_gamedetails1(inputs)
	if (locale === "da") return da_privacy_features_gamedetails1(inputs)
	if (locale === "de") return de_privacy_features_gamedetails1(inputs)
	if (locale === "en-US") return en_us2_privacy_features_gamedetails1(inputs)
	if (locale === "es-ES") return es_es2_privacy_features_gamedetails1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_features_gamedetails1(inputs)
	if (locale === "fil") return fil_privacy_features_gamedetails1(inputs)
	if (locale === "fr") return fr_privacy_features_gamedetails1(inputs)
	if (locale === "it") return it_privacy_features_gamedetails1(inputs)
	if (locale === "hu") return hu_privacy_features_gamedetails1(inputs)
	if (locale === "nl") return nl_privacy_features_gamedetails1(inputs)
	if (locale === "no") return no_privacy_features_gamedetails1(inputs)
	if (locale === "pl") return pl_privacy_features_gamedetails1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_features_gamedetails1(inputs)
	if (locale === "pt") return pt_privacy_features_gamedetails1(inputs)
	if (locale === "ro") return ro_privacy_features_gamedetails1(inputs)
	if (locale === "fi") return fi_privacy_features_gamedetails1(inputs)
	if (locale === "sv") return sv_privacy_features_gamedetails1(inputs)
	if (locale === "vi") return vi_privacy_features_gamedetails1(inputs)
	if (locale === "tr") return tr_privacy_features_gamedetails1(inputs)
	if (locale === "cs") return cs_privacy_features_gamedetails1(inputs)
	if (locale === "bg") return bg_privacy_features_gamedetails1(inputs)
	if (locale === "ru") return ru_privacy_features_gamedetails1(inputs)
	if (locale === "uk") return uk_privacy_features_gamedetails1(inputs)
	if (locale === "ar") return ar_privacy_features_gamedetails1(inputs)
	if (locale === "hi") return hi_privacy_features_gamedetails1(inputs)
	if (locale === "th") return th_privacy_features_gamedetails1(inputs)
	if (locale === "ja") return ja_privacy_features_gamedetails1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_features_gamedetails1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_features_gamedetails1(inputs)
	return ko_privacy_features_gamedetails1(inputs)
});
export { privacy_features_gamedetails1 as "privacy.features.gameDetails" }